import { render, staticRenderFns } from "./sale.vue?vue&type=template&id=78fb1b9d&scoped=true&"
import script from "./sale.vue?vue&type=script&lang=js&"
export * from "./sale.vue?vue&type=script&lang=js&"
import style0 from "./sale.vue?vue&type=style&index=0&id=78fb1b9d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fb1b9d",
  null
  
)

export default component.exports